<!--
  - Copyright (c) 2022. Venus GmbH <info@venus.bayern> - All Rights Reserved
  - Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
  - Written by Dominik Lippl <dl@venus.bayern>
  -->

<template>
  <loading-component>
    <template #content>
      <div class="flex flex-col gap-4 xl:mx-60">
        <div class="flex flex-row items-center gap-4">
          <back-component></back-component>
          <span class="text-2xl font-bold text-secondary">Scope erstellen</span>
        </div>

        <upsert-scope-component v-model="scope" @save="create" />
      </div>
    </template>
  </loading-component>
</template>

<script>
import LoadingComponent from "@/components/LoadingComponent";
import BackComponent from "@/components/BackComponent";
import UpsertScopeComponent from "@/components/scopes/UpsertScopeComponent";
import { mapStores } from "pinia";
import { useScopesStore } from "@/stores/scopes";
import Notifications from "@auth/vue-share/utility/notifications";
import FieldUtility from "@/utility/field.utility";
import logger from "@auth/vue-share/utility/logger";

export default {
  name: "CreateScope",
  components: { UpsertScopeComponent, BackComponent, LoadingComponent },
  data() {
    return {
      scope: {
        identifier: undefined,
        name: undefined,
        description: undefined,
        claims: []
      }
    };
  },
  computed: {
    ...mapStores(useScopesStore)
  },
  methods: {
    create(scope) {
      if (FieldUtility.isNull([
        "identifier",
        "name",
        "claims"
      ], scope))
        return;

      this.scopesStore.createScope(scope).then((response) => {
        Notifications.success("Scope erfolgreich erstellt");
        this.$router.push({ path: `/scopes/${response.data.data.identifier}` });
      }).catch((error) => {
        Notifications.error("Scope konnte nicht erstellt werden");
        logger.error("[SCOPE]", error);
      });
    }
  }
};
</script>

<style scoped>

</style>